module.exports = __webpack_public_path__ + "static/media/lumen.8433cf30.png";